<a
  [routerLink]="route().path"
  routerLinkActive="text-black font-semibold dark:text-white"
  [routerLinkActiveOptions]="{
    exact: route().path === '' || route().path === '/',
  }"
  #rla="routerLinkActive"
  [ngClass]="alignStart() ? 'justify-start' : 'justify-center'"
  class="flex scale-100 items-center gap-4 rounded-lg px-4 py-1 font-normal text-gray-700 duration-200 ease-in-out hover:font-semibold hover:text-black dark:text-gray-400 dark:hover:text-white">
  <ng-icon
    [name]="rla.isActive ? route().iconFilled : route().iconOutline"
    size="20px" />
  <span class="text-nowrap">{{ route().title }}</span>
</a>
